import React, { useState } from "react";
import SideBar from "../layouts/SideBar";
import { Outlet } from "react-router-dom";

function AdminMainDashboard() {

  const [open, setOpen] = useState(false);

  return (
    <div className="admin-layout">

   <button
  className="sidebar-toggle"
  onClick={() => setOpen(!open)}
>
  {open ? "✖" : "☰"}
</button>


      <div className={`dash-board-side-bar ${open ? "open" : ""}`}>
        <SideBar  setOpen={setOpen}  open={open}  />
      </div>

      <div className={`dash-board-main-content-container ${open ? "shift" : ""}`}>
        <div className="admin-page-content">
          <Outlet />
        </div>
      </div>

    </div>
  );
}

export default AdminMainDashboard;